exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1SUYw-UAYi2aAqt12aQVeK{text-align:center}\n", ""]);

// exports
exports.locals = {
	"textAlign": "_1SUYw-UAYi2aAqt12aQVeK"
};